export class ButtonToggle {
  intentCode: string;
  label: string;
  isSelected: boolean;
  groupId?: number;
  sequence?: number;
  isDisabled?: boolean;
  hideCoverage?: boolean;
}
